import React from 'react'
import { IconContext } from 'react-icons'
import { RiLogoutBoxLine } from 'react-icons/ri';
import { useAuth } from '@murphy-frontend/web-core/features/auth/WebAuthProvider';
import { useUserPreferences } from "../../../contexts/UserPreferencesContext";

const LogoutButton = () => {
	const auth = useAuth();
	const { translations } = useUserPreferences();

	const handleLogout = () => {
		auth.signOut();
	}

	return (
		<li className="sidebar-settings-list" onClick={handleLogout}>
			<div className='sidebar-text-wrapper'>
				<div className='sidebar-link sidebar-link-nested logout-button'>
					<IconContext.Provider value={{ className: "sidebar-icon" }}>
						<RiLogoutBoxLine />
					</IconContext.Provider>
					<div className='sidebar-text'>
						{translations['lang-logga-ut'] ?? 'Log out'}
					</div>
				</div>
			</div>
		</li>
	)
}

export default LogoutButton